import { render, staticRenderFns } from "./CalendarFormComments.vue?vue&type=template&id=34fbbd6c"
import script from "./CalendarFormComments.vue?vue&type=script&lang=js"
export * from "./CalendarFormComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports